import { uniqueId } from 'lodash/fp';
import { PATH_BUILDER } from '../../constants/actionTypes';

/**
 * Path
 */

export const updatePath = changes => ({
  type: PATH_BUILDER.PATH.UPDATE,
  changes,
});

export const updateRequestInProgress = () => ({
  type: PATH_BUILDER.PATH.UPDATE_IN_PROGRESS,
});

export const updateRequestSuccess = () => ({
  type: PATH_BUILDER.PATH.UPDATE_SUCCESS,
});

export const updateRequestFailure = () => ({
  type: PATH_BUILDER.PATH.UPDATE_FAILURE,
});

export const dismissUpdateRequestFailure = () => ({
  type: PATH_BUILDER.PATH.UPDATE_FAILURE_DISMISS,
});

export const publishPath = (user, date) => ({
  type: PATH_BUILDER.PATH.PUBLISH,
  user,
  date,
});

export const toggleEditingDescription = () => ({
  type: PATH_BUILDER.PATH.TOGGLE_EDITING_DESCRIPTION,
});

export const toggleEditingOrderEnforcement = () => ({
  type: PATH_BUILDER.PATH.TOGGLE_EDITING_ORDER_ENFORCEMENT,
});

export const setEstimatedMinutesToComplete = estimatedMinutesToComplete => ({
  type: PATH_BUILDER.PATH.SET_ESTIMATED_MINUTES_TO_COMPLETE,
  estimatedMinutesToComplete,
});

/**
 * Draft and Revision
 */

export const saveRevision = () => ({
  type: PATH_BUILDER.PATH.SAVE_REVISION,
});

export const restoreRevision = () => ({
  type: PATH_BUILDER.PATH.RESTORE_REVISION,
});

/**
 * Contents
 */

export const updateContent = (id, contentType, changes) => ({
  type: PATH_BUILDER.CONTENT.UPDATE,
  id,
  contentType,
  changes,
});

export const reorderContent = (position, newPosition) => ({
  type: PATH_BUILDER.CONTENT.REORDER,
  position,
  newPosition,
});

export const removeContent = (id, type) => ({
  type: PATH_BUILDER.CONTENT.REMOVE,
  contentType: type,
  id,
});

export const addContent = (contentType, position, content) => ({
  type: PATH_BUILDER.CONTENT.ADD,
  id: uniqueId('tmp#'),
  justAdded: true,
  contentType,
  position,
  ...content,
});

export const toggleEditing = (id, contentType, view) => ({
  type: PATH_BUILDER.CONTENT.TOGGLE_EDITING,
  contentType,
  id,
  view,
});

export const persistContent = (id, contentType) => ({
  type: PATH_BUILDER.CONTENT.PERSIST,
  contentType,
  id,
});

export const toggleEditingMode = () => ({
  type: PATH_BUILDER.PATH.TOGGLE_EDITING_MODE,
});

export const toggleDraggingContent = () => ({
  type: PATH_BUILDER.CONTENT.TOGGLE_DRAGGING,
});

/**
 * UI Actions
 */

export const toggleEditingUIElementByName = name => ({
  type: PATH_BUILDER.UI.TOGGLE_EDITING_BY_NAME,
  name,
});

export const setMode = mode => ({
  type: PATH_BUILDER.UI.SET_MODE,
  mode,
});

export const requestReportingData = () => ({
  type: PATH_BUILDER.REPORTING.DATA_REQUEST,
});

export const requestReportingDataSuccess = data => ({
  type: PATH_BUILDER.REPORTING.DATA_SUCCESS,
  data,
});

export const loadingContent = (id, contentType) => ({
  type: PATH_BUILDER.CONTENT.LOADING_CONTENTS_REQUEST,
  id,
  contentType,
});

export const loadingContentSuccess = (id, contentType) => ({
  type: PATH_BUILDER.CONTENT.LOADING_CONTENTS_SUCCESS,
  id,
  contentType,
});
